<template>
  <section>
    <Header :class="{scrolled: scrolled}" ref="header"/>
    <div class="accountCnt">
      <div class="loading" v-if="loading"></div>
      <div class="accountInfo" v-else-if="notFound">
        <h4>404</h4>
        <p v-if="lang === 'id'">Link untuk verifikasi alamat email
          tidak ditemukan, mungkin link verifikasi sudah kadaluarsa.</p>
        <p v-if="lang === 'en'">Email verification link not found,
          maybe you clicked the wrong url or the verification link
          has been expired.</p>
        <a :href="`${$config.appPath}${langCode}`" class="btn secondary">
          <template v-if="lang === 'id'">Halaman Utama</template>
          <template v-else>Back To Home</template>
        </a>
      </div>
      <div class="success" v-else>
        <div class="success-animation">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"><circle class="checkmark__circle"
            cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check"
            fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
        </div>
        <h4 v-if="lang === 'id'">Verifikasi Email Sukses</h4>
        <h4 v-if="lang === 'en'">Email Verification Success</h4>
        <p v-if="lang === 'id'">Terima kasih telah melakukan verifikasi Email.</p>
        <p v-if="lang === 'en'">Thank you for verifying your Email Address.</p>
        <a :href="`${$config.appPath}${langCode}`" class="btn secondary">
          <template v-if="lang === 'id'">Halaman Utama</template>
          <template v-else>Back To Home</template>
        </a>
      </div>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'library',
  components: { Header, Footer },
  data() {
    return {
      scrolled: false,
      loading: true,
      notFound: false,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    this.loading = true;
    this.$http.post(this.$config.uri('user/subscribe/verify'), {
      token: this.$route.params.token,
    }).then((response) => {
      this.loading = false;
      if (response.data.status !== 200) this.notFound = true;
    });
  },
};
</script>

<style scoped lang="scss">
.accountCnt{
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 74px);
  @media (max-width: 1480px) {
    min-height: calc(100vh - 64px);
  }
  .loading{
    width: 100px; height: 100px;
    background-image: url(../assets/loading.svg);
    background-size: 56px auto;
    background-position: center;
    background-repeat: no-repeat;
    margin-bottom: 60px;
  }
  .success{
    max-width: 640px;
    padding: 0 20px;
    box-sizing: border-box;
    h4{
      margin: 0 0 4px;
      font-size: 20px;
      font-weight: 500;
    }
    p{
      margin: 0 0 16px;
      color: #767676;
      font-size: 15px;
    }
    .success-animation{
      margin-bottom: 24px;
      .checkmark{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: block;
        stroke-width: 2;
        stroke: #4bb71b;
        stroke-miterlimit: 10;
        box-shadow: inset 0px 0px 0px #4bb71b;
        animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
        margin: 0 auto;
      }
      .checkmark__circle{
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke: #4bb71b;
        fill: #f5f5f5;
        animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
      }
      .checkmark__check{
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
      }
      @keyframes stroke {
        100% {
          stroke-dashoffset: 0;
        }
      }
      @keyframes scale {
        0%, 100% {
          transform: none;
        }
        50% {
          transform: scale3d(1.1, 1.1, 1);
        }
      }
      @keyframes fill {
        100% {
          box-shadow: inset 0px 0px 0px 30px #4bb71b;
        }
      }
    }
  }
  .accountInfo{
    padding: 30px 20px;
    box-sizing: border-box;
    max-width: 640px;
    text-align: center;
    .fieldGroup{
      text-align: left;
    }
    h4{
      margin: 0 0 6px;
      font-size: 34px;
    }
    p{
      margin: 0 0 20px;
      font-size: 18px;
      line-height: 1.3;
      b{
        white-space: nowrap;
      }
    }
    .btnCnt{
      // text-align: right;
      margin-top: 26px;
      .btn{
        width: 100%;
        border-radius: 3px;
      }
    }
    @media (max-width: 680px) {
      h4 {
        font-size: 30px;
      }
    }
  }
}
</style>
